export const QuotaLevels = {
  HIGH: 3,
  MID: 2,
  LOW: 1,
  NONE: 0,
};
